export default __webpack_public_path__ + "static/media/Cuvette.2697a1a1.svg";